import { useUserPositionOptions } from "../hooks/useUserPositionOptions.js";
import "react";
import { ColorSquare, Skeleton } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
//#region src/modules/Users/shared/UserPosition.tsx
function UserPosition({ className, id, showColor, size }) {
	const { data, loading } = useUserPositionOptions({ idFilter: [id] }, { cacheStrategy: "cache-only" });
	const position = data?.userPositionOptions?.[0];
	if (!position && loading) return /* @__PURE__ */ jsx("span", { children: /* @__PURE__ */ jsx(Skeleton.Text, { chars: 12 }) });
	return /* @__PURE__ */ jsxs("span", {
		className: classnames({
			"space-x-xs": size !== "sm",
			"space-x-xxs text-sm": size === "sm"
		}, className),
		children: [showColor && position?.color && /* @__PURE__ */ jsx("span", {
			className: "my-auto inline-block",
			children: /* @__PURE__ */ jsx(ColorSquare, {
				color: position.color,
				size
			})
		}), /* @__PURE__ */ jsx("span", { children: position?.title })]
	});
}
//#endregion
export { UserPosition };

//# sourceMappingURL=UserPosition.js.map